import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import Button from '@components/common/button';
import { useLocales } from '@hooks/helpers/useLocales';
// TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
// import linkCardIllustration from '@svg/illustrations/link_eps.svg';
import linkBankIllustration from '@svg/illustrations/link_bank.svg';

interface IProps {
    onChange: (value: 'card' | 'bank') => void;
}

const ChooseTypeSection: FC<IProps> = ({ onChange }) => {
    const { submitLocale } = useLocales();
    const { t } = useTranslation('sections', {
        keyPrefix: 'link_card_bank.choose_type'
    });

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
            <div className={`${styles.card}`} onClick={() => onChange('card')}>
                <img src={linkCardIllustration} alt="illustration" />
                <div className={styles.text_wrapper}>
                    <Typography className={styles.title} variant="body1" weight="semibold">
                        {t('credit')}
                    </Typography>
                    <p className={styles.description}>{t('accept_credit')}</p>
                </div>
                <Button variant="primary" onClick={() => onChange('card')}>
                    {submitLocale('link_card')}
                </Button>
            </div>
            */}
            <div className={styles.card} onClick={() => onChange('bank')}>
                <img src={linkBankIllustration} alt="illustration" />
                <div className={styles.text_wrapper}>
                    <Typography className={styles.title} variant="body1" weight="semibold">
                        {t('bank')}
                    </Typography>
                    <p className={styles.description}>{t('accept_bank')}</p>
                </div>
                <Button variant="primary" onClick={() => onChange('bank')}>
                    {submitLocale('link_bank_account')}
                </Button>
            </div>
        </motion.div>
    );
};

export default ChooseTypeSection;
